<template>
  <footer v-if="socials" class="social-footer">
    <h2 class="social-header">Connect with Polly Dugan</h2>
    <div class="social-links">
      <a href="https://www.facebook.com/polly.dugan/" target="_blank"
        ><i class="fab fa-facebook-f"></i
      ></a>
      <a href="https://www.instagram.com/polly_dugan/" target="_blank"
        ><i class="fab fa-instagram"></i
      ></a>
      <a href="https://www.linkedin.com/in/polly-dugan-ba844836" target="_blank"
        ><i class="fab fa-linkedin-in"></i
      ></a>
    </div>
  </footer>
  <footer class="footer">
    <p>&copy; {{ year }} Polly Dugan. All rights reserved.</p>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
  props: {
    socials: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped>
.footer {
  background-color: var(--main-green);
  color: white;
  text-align: center;
  padding: 1rem;
  margin-top: auto;
  font-family: "Frank Ruhl Libre", serif;
}

.footer p {
  margin: 0;
  font-size: 1rem;
}

.social-footer {
  background: linear-gradient(
    to bottom,
    var(--main-footer),
    var(--secondary-footer)
  );
  padding: 1rem;
  text-align: center;
  color: white;
  font-family: "Frank Ruhl Libre", serif;
}

.social-footer .social-links {
  display: flex;
  justify-content: center;
  gap: 2rem;
  padding: 1rem;
}

.social-footer .social-links a {
  color: white;
  font-size: 2rem;
  text-decoration: none;
  transition: all 0.2s ease;
}

.social-footer .social-links a:hover {
  color: var(--main-accent);
  transform: scale(1.05);
}
.social-header {
  font-size: 1.5em;
  margin: 1rem;
}
</style>
